<template>
  <ShortDisplayCard :bigger-right="true">
    <template v-slot:logo>
      <MarketLogoVue :market="market" style="width: 2.85rem; height: 2.85rem; margin-left: calc(2.85rem * 0.2)"
        class="_sm_pmg1v_17" />
    </template>
    <template v-slot:right-1>
      {{ market.baseAsset.name }} - {{ product == 'cms' && market.quoteAsset.name == 'Toman' ? 'IRT' : market.quoteAsset.name }}
    </template>
    <template v-slot:left-1>
      <span class="_price_1e8ul_1">
        <span class="_value_1e8ul_4">{{
          $filters.prettyAndFormatDecimal(market.bestPriceToBuy, market.priceDecimals)
        }}</span><span class="_suffix_1e8ul_7">{{ market.quoteAsset.symbol }}</span></span>
    </template>
    <template v-slot:right-2>
      <span class="secondary">{{ market.baseAsset.symbol }}/{{ market.quoteAsset.symbol }}</span>
    </template>
  </ShortDisplayCard>
</template>

<script>
import MarketLogoVue from './MarketLogo.vue'
import ShortDisplayCard from '../../components/list/ShortDisplayCard.vue';
import settings from '../../settings';

export default {
  data() {
    return {
      product: settings.PRODUCT
    }
  },
  props: {
    market: {
      required: true
    }
  },
  components: {
    MarketLogoVue,
    ShortDisplayCard
  }
}
</script>

<style></style>